const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ombdhlkdz2.execute-api.eu-north-1.amazonaws.com/dev';
const COMPANY_ID = process.env.REACT_APP_COMPANY_ID || 'bandn';

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const config = {
      method: options.method || 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    if (options.body) {
      config.body = JSON.stringify(options.body);
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || 'Request failed');
      }

      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  async requestOtp(email) {
    return this.request('/v1/auth/otp/request', {
      body: {
        companyId: COMPANY_ID,
        email: email.toLowerCase(),
      },
    });
  }

  async verifyOtp(email, code) {
    return this.request('/v1/auth/otp/verify', {
      body: {
        companyId: COMPANY_ID,
        email: email.toLowerCase(),
        code,
      },
    });
  }

  async submitApplication(email, applicationData) {
    return this.request('/v1/applications/submit', {
      body: {
        companyId: COMPANY_ID,
        email: email.toLowerCase(),
        applicationData,
      },
    });
  }

  async getApplications(status = null, limit = 1000) {
    const params = new URLSearchParams({
      companyId: COMPANY_ID,
      limit: limit.toString(),
    });
    
    if (status) {
      params.append('status', status);
    }

    return this.request(`/v1/admin/applications?${params.toString()}`, {
      method: 'GET',
    });
  }

  async updateApplicationStatus(applicationId, status, notes = '') {
    return this.request('/v1/admin/applications/status', {
      method: 'PUT',
      body: {
        companyId: COMPANY_ID,
        applicationId,
        status,
        notes,
      },
    });
  }

  async deleteApplications(applicationIds) {
    return this.request('/v1/admin/applications', {
      method: 'DELETE',
      body: {
        companyId: COMPANY_ID,
        applicationIds,
      },
    });
  }

  async submitContract(contractData) {
    return this.request('/v1/contracts/submit', {
      method: 'POST',
      body: {
        companyId: COMPANY_ID,
        ...contractData,
      },
    });
  }

  async getContracts() {
    return this.request(`/v1/admin/contracts?companyId=${COMPANY_ID}`, {
      method: 'GET',
    });
  }

  async deleteContracts(contractIds) {
    return this.request('/v1/admin/contracts', {
      method: 'DELETE',
      body: {
        companyId: COMPANY_ID,
        contractIds,
      },
    });
  }

  // ─── AUHCA contract signing integration ──────────────────────────
  // Pre-fill data for the signing page. refId is the URL-path bearer
  // shared with AUHCA. Returns { candidate, employer } or throws.
  async getSigningDetails(refId) {
    return this.request(`/v1/sign/${encodeURIComponent(refId)}/details`, {
      method: 'GET',
    });
  }

  // Submit the signed contract. payload = { signedName, address?,
  // idNumber?, signedAt, signatureDataUrl, signatureMode? }. Returns
  // { signedAt, alreadyCompleted, pdfDownloadUrl }.
  async submitSigning(refId, payload) {
    return this.request(`/v1/sign/${encodeURIComponent(refId)}/submit`, {
      method: 'POST',
      body: payload,
    });
  }
}

export default new ApiService();
